<template>
    <div class="float-left">

        <i
            class="fa fa-paper-plane fa-lg icon-button"
            title="Encaminhar"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalEncaminharProcessos"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div>
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            ENCAMINHAR PROCESSOS DA ATA DIREX
                             {{ ataDirex.nuAtaDirex }} -
                             {{ ataDirex.tipoAta}} -
                             {{ ataDirex.dtReuniao ? $moment(ataDirex.dtReuniao).format(
                                      'DD/MM/YYYY'
                                  )
                              : '' }} -
                                {{ ataDirex.situacaoAta}}
                        </span>
                    </b-card-header>

                    <b-card-body>

                        <app-tabela
                            :itens="processosatadirexLista"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"

                        >
                            <template slot="check" slot-scope="data">
                                <b-form-checkbox
                                    :value="data.idProcessoAta"
                                    v-model="processosSelecionados"
                                    v-if="data.idSituacaoProcesso!=3"
                                ></b-form-checkbox>
                            </template>
                            <template slot="situacaoProcesso" slot-scope="data">
                                <app-status
                                    :status="data.situacaoProcesso.toUpperCase()"
                                ></app-status>
                            </template>


                        </app-tabela>
                    </b-card-body>
                </b-card>
            </div>

            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Fechar</b-button
                >
                <b-button
                    variant="success"
                    @click.stop="confirmarEncaminhar()"
                    class="ml-1"
                    :disabled="$v.$invalid"
                    >Encaminhar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import AtaDirexServicos from './AtaDirexServicos'

export default {

    validations: {
            processosSelecionados: {
                valida(){
                    return this.processosSelecionados.length > 0
                }
            }
        },

    props: {
        /*idAta: {
                type: Number,
                default: 0
            }*/
        ataDirex: {
            type: Object,
            default: () => ({})
        }
    },


    data() {
        return {
            mostrarModal: false,
            processosSelecionados : [],
            processosatadirexLista:[],
            itensPorPagina: 5,
            campos: [
                {
                    key: 'check',
                    label: 'Selecione'
                },
                {
                    key: 'nuProcesso',
                    label: 'Processo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcObjetoProcesso',
                    label: 'Objeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'situacaoProcesso',
                    label: 'Situação',
                    sortable: true,
                    filterable: true
                },
            ]
        }
    },

    methods: {

        abrirModal() {
            this.mostrarModal = true;
            this.processosSelecionados = [],
            this.listar();
        },

        fecharModal() {
            this.mostrarModal = false;
        },

        listar(){
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ListarProcessosAtaDirex(this.ataDirex.idAtaDirex).then(response => {
                if (response) {
                    if (response.success) {
                        this.processosatadirexLista = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarEncaminhar() {
            this.$swal({
                title: 'Encaminhar Processo(s) da Ata Direx '+this.ataDirex.nuAtaDirex,
                html: `Confirma o Encaminhamento do(s) Processo(s) Selecionado(s)?
                <br/><br/>`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.encaminhar()
                }
            })
        },

        encaminhar(){
            this.$store.dispatch('addRequest')
            AtaDirexServicos.EnviarProcessosPorEmail(this.ataDirex.idAtaDirex, this.processosSelecionados).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('listarAtas')
                        this.fecharModal()
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
}
</script>

